const actions = {
  SEARCH_REQUEST: "SLACK_MEETING_STORE_MAPPING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "SLACK_MEETING_STORE_MAPPING/SEARCH_SUCCESS",
  SEARCH_ERROR: "SLACK_MEETING_STORE_MAPPING/SEARCH_ERROR",

  DETAIL_REQUEST: "SLACK_MEETING_STORE_MAPPING/DETAIL_REQUEST",
  DETAIL_SUCCESS: "SLACK_MEETING_STORE_MAPPING/DETAIL_SUCCESS",
  DETAIL_ERROR: "SLACK_MEETING_STORE_MAPPING/DETAIL_ERROR",

  CREATE_REQUEST: "SLACK_MEETING_STORE_MAPPING/CREATE_REQUEST",
  CREATE_SUCCESS: "SLACK_MEETING_STORE_MAPPING/CREATE_SUCCESS",
  CREATE_ERROR: "SLACK_MEETING_STORE_MAPPING/CREATE_ERROR",

  UPDATE_REQUEST: "SLACK_MEETING_STORE_MAPPING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "SLACK_MEETING_STORE_MAPPING/UPDATE_SUCCESS",
  UPDATE_ERROR: "SLACK_MEETING_STORE_MAPPING/UPDATE_ERROR",

  DELETE_REQUEST: "SLACK_MEETING_STORE_MAPPING/DELETE_REQUEST",
  DELETE_SUCCESS: "SLACK_MEETING_STORE_MAPPING/DELETE_SUCCESS",
  DELETE_ERROR: "SLACK_MEETING_STORE_MAPPING/DELETE_ERROR",

  RESET_DETAIL: "SLACK_MEETING_STORE_MAPPING/RESET_DETAIL",

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
